import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PresetCountriesDynamicComponentHelper} from '@features/preset-countries/preset-countries-dynamic-component-helper';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {AddPresetCountriesCommandHandler} from '@features/preset-countries/services/add-preset-countries-command-handler';
import {RouterModule} from "@angular/router";
import {PresetCountriesRoutes} from "@features/preset-countries/preset-countries.routes";
import { AddPresetCountriesComponent } from './components/add-preset-countries/add-preset-countries.component';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {PlatformToolPresetCountriesHandler} from "@features/preset-countries/services/platform-tool-preset-countries-handler";



@NgModule({
  declarations: [
    AddPresetCountriesComponent
  ],
  imports: [
    RouterModule.forChild(PresetCountriesRoutes),
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class PresetCountriesModule {
  constructor(private commandService: CommandService,
              private platformToolPresetCountriesHandler: PlatformToolPresetCountriesHandler,
              private addPresetCountriesCommandHandler: AddPresetCountriesCommandHandler) {
    PresetCountriesDynamicComponentHelper.init();
    PresetCountriesDynamicComponentHelper.register('PlatformToolPresetCountriesHandler', platformToolPresetCountriesHandler);
    PresetCountriesDynamicComponentHelper.register('AddPresetCountriesCommandHandler', addPresetCountriesCommandHandler);

    const presetCountriesCommand = new PlatformCommand('CreatePresetCountriesToolLinkCommand', 'EntityChartApi');
    this.commandService.registrPlatformLinkCommand('/preset-countries', presetCountriesCommand);
  }
}
